import { useState, useEffect } from 'react';

const getStorageValue = (key, defaultValue) => {
    // getting stored value
    const saved = localStorage.getItem(key);
    const initial = JSON.parse(saved);
    return initial || defaultValue;
};

export const useLocalStorage = (key, defaultValue) => {
    const [value, setValue] = useState(() =>
        getStorageValue(key, defaultValue),
    );

    useEffect(() => {
        // storing input name
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
};
